import { render, staticRenderFns } from "./CustomLayout.vue?vue&type=template&id=79c2b1d0&scoped=true"
import script from "./CustomLayout.vue?vue&type=script&lang=ts"
export * from "./CustomLayout.vue?vue&type=script&lang=ts"
import style0 from "./CustomLayout.vue?vue&type=style&index=0&id=79c2b1d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c2b1d0",
  null
  
)

export default component.exports